import { render } from "./OAOConfirmation.vue?vue&type=template&id=7ce8f66c&scoped=true"
import script from "./OAOConfirmation.vue?vue&type=script&lang=js"
export * from "./OAOConfirmation.vue?vue&type=script&lang=js"

import "./OAOConfirmation.vue?vue&type=style&index=0&id=7ce8f66c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce8f66c"]])

export default __exports__